module.exports = __webpack_public_path__ + "danceparty2wpa1cb8e7c2ce04e3447ffeb59d77098c6.png";